import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import { Field } from "redux-form/immutable";

import DatePickerField from "app/components/form/DatePickerField";
import { WorkScheduleDefinitionMapper } from "features/planner/planner.mappers";
import { WORK_SCHEDULE_FORM } from "features/planner/employee/employee.constants";
import { getWorkScheduleDefinitionFromState } from "features/planner/employee/employee.selectors";
import SelectWorkScheduleDefinition from "features/planner/employee/schedule/components/SelectWorkScheduleDefinition";

const workScheduleDefinitionIsNotFinite = workScheduleDefinition =>
  workScheduleDefinition.get("dayCount") < 0;

const SimpleWorkScheduleForm = ({ handleSubmit }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Field
            name={WORK_SCHEDULE_FORM.DEFINITION}
            component={SelectWorkScheduleDefinitionField}
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            component={DatePickerField}
            name={WORK_SCHEDULE_FORM.START_DATE}
            DatePickerProps={{
              label: "Start Date",
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            component={DatePickerField}
            name={WORK_SCHEDULE_FORM.END_DATE}
            DatePickerProps={{
              label: "End Date",
            }}
          />
        </Grid>
      </Grid>
    </form>
  );
};

const SelectWorkScheduleDefinitionField = ({ input }) => (
  <SelectWorkScheduleDefinition
    filter={workScheduleDefinitionIsNotFinite}
    value={input.value}
    onChange={input.onChange}
    TextFieldProps={{
      margin: "normal",
    }}
  />
);

SimpleWorkScheduleForm.defaultProps = {
  selectedWorkScheduleDefinition: WorkScheduleDefinitionMapper.initial(),
};

export default compose(
  connect((state, { formValueSelector }) => {
    const selectedWorkScheduleDefinitionId = formValueSelector(
      state,
      WORK_SCHEDULE_FORM.DEFINITION,
    );

    return {
      selectedWorkScheduleDefinition: selectedWorkScheduleDefinitionId
        ? getWorkScheduleDefinitionFromState(
            state,
            selectedWorkScheduleDefinitionId,
          )
        : undefined,
    };
  }),
  React.memo,
)(SimpleWorkScheduleForm);
